import { render, staticRenderFns } from "./TrainingCreate.vue?vue&type=template&id=dc18c1cc"
import script from "./TrainingCreate.vue?vue&type=script&lang=ts"
export * from "./TrainingCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports